// Table column filter dropdowns (.com-custom-table-tag-filter) sit inside a .table-responsive
// wrapper whose overflow clips the menu when the table has only a few rows.
// Bootstrap reads data-bs-popper-config when it creates the dropdown on the first click, so we
// set a "fixed" Popper strategy just before that. Bootstrap's delegated click handler is itself a
// capture listener on document, so this one must be on window to run first. The menu is then
// positioned against the viewport and is never clipped.
const TOGGLE_SELECTOR = '.com-custom-table-tag-filter [data-bs-toggle="dropdown"]';
const POPPER_CONFIG = JSON.stringify({ strategy: "fixed" });

export const registerTableFilterDropdownFix = () => {
  window.addEventListener(
    "click",
    (event) => {
      const toggle = event.target.closest?.(TOGGLE_SELECTOR);
      if (toggle && !toggle.hasAttribute("data-bs-popper-config")) {
        toggle.setAttribute("data-bs-popper-config", POPPER_CONFIG);
      }
    },
    true
  );
};
